/* Faded Archive – Theme-Steuerung (ohne Bibliotheken).
   Bausteine: Kopfzeile + Menüs, Schubladen (Menü, Warenkorb, Filter), Live-Suche, Warenkorb (Shopify Ajax API),
   Produktseite, Karusselle, Reiter, Laufbänder, Einblendungen, 360°-Ansicht. Alles lässt sich im Theme-Editor neu starten. */
(function () {
  'use strict';
  var W = window, D = document, VF = W.VF || {}, R = VF.routes || {};
  var $ = function (s, r) { return (r || D).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || D).querySelectorAll(s)); };
  var mq = function (q) { return W.matchMedia ? W.matchMedia(q) : { matches: false }; };
  var REDUCE = mq('(prefers-reduced-motion: reduce)').matches;
  var FINE = mq('(hover: hover) and (pointer: fine)');
  var ANIM = D.documentElement.classList.contains('vf-anim') && !REDUCE;
  var clamp = function (v, a, b) { a = a === undefined ? 0 : a; b = b === undefined ? 1 : b; return Math.min(b, Math.max(a, v)); };
  var easeIO = function (t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var ajax = function (p, ext) { return String(p || '').replace(/\/$/, '') + (ext || '.js'); };
  var sized = function (url, w) { if (!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; };
  var SVG = function (d) { return '<svg class="vf-ico" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' + d + '</svg>'; };
  var ICON = {
    close: SVG('<path d="M6 6l12 12M18 6 6 18"/>'),
    left: SVG('<path d="M20 12H4M10 6l-6 6 6 6"/>'),
    right: SVG('<path d="M4 12h16M14 6l6 6-6 6"/>'),
    bag: '<svg class="vf-ico" viewBox="0 0 24 24" aria-hidden="true" focusable="false" style="stroke-width:1.1"><path d="M5 8h14l-1.1 11.4a1.7 1.7 0 0 1-1.7 1.6H7.8a1.7 1.7 0 0 1-1.7-1.6Z"/><path d="M9 10V6.8a3 3 0 0 1 6 0V10"/></svg>'
  };

  /* ---------- Geld wie im Shop formatieren (shop.money_format) */
  function money(cents) {
    var fmt = VF.money || '{{amount_with_comma_separator}} €';
    var neg = cents < 0, n = Math.abs(Number(cents) || 0) / 100;
    var fix = function (v, d, ts, ds) {
      var p = v.toFixed(d).split('.');
      return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts) + (p[1] ? ds + p[1] : '');
    };
    var out = fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount': return fix(n, 2, ',', '.');
        case 'amount_no_decimals': return fix(n, 0, ',', '.');
        case 'amount_with_comma_separator': return fix(n, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fix(n, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fix(n, 2, "'", '.');
        case 'amount_with_space_separator': return fix(n, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return fix(n, 0, ' ', '');
        case 'amount_with_period_and_space_separator': return fix(n, 2, ' ', '.');
        default: return fix(n, 2, '.', ',');
      }
    });
    return (neg ? '−' : '') + out.replace(/<[^>]*>/g, '');
  }

  /* ---------- Hinweis unten (Toast) */
  var toastT = 0;
  function toast(msg) {
    var t = $('[data-toast]'); if (!t) return;
    t.textContent = msg; t.classList.add('is-on');
    clearTimeout(toastT); toastT = setTimeout(function () { t.classList.remove('is-on'); }, 2800);
  }

  /* ---------- Ebenen: Schubladen (Menü, Warenkorb, Filter) + Such-Blatt am Handy */
  var overlay = D.createElement('div');
  overlay.className = 'vf-overlay'; overlay.hidden = true; overlay.setAttribute('aria-hidden', 'true');
  D.body.appendChild(overlay);
  var layer = null, hideT = 0;
  function lock(on) { D.body.classList.toggle('is-locked', !!on); }
  function showLayer(el, opener) {
    if (!el) return;
    if (layer && layer.el === el) return;
    if (layer) hideLayer(false);
    clearTimeout(hideT);
    el.hidden = false; overlay.hidden = false;
    void el.offsetWidth;
    el.classList.add('is-open'); overlay.classList.add('is-on');
    lock(true);
    layer = { el: el, opener: opener || null };
    if (opener) opener.setAttribute('aria-expanded', 'true');
    var focusEl = el.matches('[data-sheet]') ? $('input[type=search]', el) : el;
    setTimeout(function () { if (layer && layer.el === el && focusEl) focusEl.focus({ preventScroll: true }); }, 80);
  }
  function hideLayer(restore) {
    if (!layer) return;
    var el = layer.el, opener = layer.opener; layer = null;
    el.classList.remove('is-open'); overlay.classList.remove('is-on');
    if (opener) opener.setAttribute('aria-expanded', 'false');
    if (!lb) lock(false);
    setTimeout(function () {
      if (!el.classList.contains('is-open')) el.hidden = true;
      if (!layer) overlay.hidden = true;
    }, 520);
    if (restore !== false && opener && D.body.contains(opener) && opener.offsetParent !== null) opener.focus({ preventScroll: true });
  }
  overlay.addEventListener('click', function () { hideLayer(); });
  function focusables(root) {
    return $$('a[href],button:not([disabled]),input:not([disabled]):not([type=hidden]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])', root)
      .filter(function (x) { return x.offsetParent !== null || x === D.activeElement; });
  }
  function trap(e, root) {
    var f = focusables(root); if (!f.length) { e.preventDefault(); return; }
    var first = f[0], last = f[f.length - 1], a = D.activeElement;
    if (e.shiftKey && (a === first || a === root || !root.contains(a))) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (a === last || !root.contains(a))) { e.preventDefault(); first.focus(); }
  }

  /* ---------- Kopfzeile: Schatten beim Scrollen, großes Menü */
  function measureBars() {
    var ann = $('.vf-ann');
    D.documentElement.style.setProperty('--ann-h', (ann ? ann.offsetHeight : 0) + 'px');
  }
  function closeMega(except) {
    $$('[data-mega].is-open').forEach(function (li) {
      if (li === except) return;
      li.classList.remove('is-open');
      var a = $('.vf-nav__a', li); if (a) a.setAttribute('aria-expanded', 'false');
    });
  }
  function initMega(root) {
    $$('[data-mega]', root).forEach(function (li) {
      if (li._vf) return; li._vf = 1;
      var a = $('.vf-nav__a', li), t = 0;
      var open = function () { clearTimeout(t); closeMega(li); li.classList.add('is-open'); if (a) a.setAttribute('aria-expanded', 'true'); };
      var close = function () { clearTimeout(t); li.classList.remove('is-open'); if (a) a.setAttribute('aria-expanded', 'false'); };
      li.addEventListener('mouseenter', function () { if (!FINE.matches) return; clearTimeout(t); t = setTimeout(open, 70); });
      li.addEventListener('mouseleave', function () { if (!FINE.matches) return; clearTimeout(t); t = setTimeout(close, 180); });
      if (a) a.addEventListener('click', function (e) {
        if (li.classList.contains('is-open')) return;
        if (FINE.matches && e.detail > 0) return;          // Maus: Link öffnet normal
        e.preventDefault(); open();                           // Touch/Tastatur: erst aufklappen
      });
      li.addEventListener('focusout', function (e) { if (!li.contains(e.relatedTarget)) close(); });
      li.addEventListener('keydown', function (e) { if (e.key === 'Escape' && li.classList.contains('is-open')) { e.stopPropagation(); close(); if (a) a.focus(); } });
    });
  }

  /* ---------- Live-Suche (Shopify Predictive Search) */
  function initSearch(root) {
    $$('[data-search]', root).forEach(function (form) {
      var input = $('[data-search-input]', form), drop = $('[data-search-drop]', form);
      if (!input || !drop || form._vf) return; form._vf = 1;
      var timer = 0, ctrl = null, sel = -1, lastQ = '';
      var close = function () { drop.hidden = true; input.setAttribute('aria-expanded', 'false'); input.removeAttribute('aria-activedescendant'); sel = -1; };
      var opts = function () { return $$('[role=option]', drop); };
      var mark = function (i) {
        var o = opts(); sel = i;
        o.forEach(function (x, k) { x.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
        if (o[i]) { input.setAttribute('aria-activedescendant', o[i].id); o[i].scrollIntoView({ block: 'nearest' }); }
      };
      var allUrl = function (q) { return (R.search || '/search') + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last'; };
      var render = function (q, ps) {
        var html = ps.map(function (p, i) {
          var img = (p.featured_image && p.featured_image.url) || p.image;
          var price = p.price != null ? money(Math.round(parseFloat(p.price) * 100)) : '';
          return '<a class="vf-sug" role="option" id="' + drop.id + '-' + i + '" aria-selected="false" href="' + esc(p.url) + '">' +
            '<span class="vf-sug__img">' + (img ? '<img src="' + esc(sized(img, 160)) + '" alt="" loading="lazy" width="52" height="65">' : '') + '</span>' +
            '<span class="vf-sug__t">' + esc(p.title) + '</span><span class="vf-sug__p">' + esc(price) + '</span></a>';
        }).join('');
        if (!ps.length) html = '<p class="vf-sug-empty">Keine Treffer für „' + esc(q) + '“.</p>';
        drop.innerHTML = html + '<a class="vf-sug-all" href="' + esc(allUrl(q)) + '">Alle Ergebnisse für „' + esc(q) + '“' + ICON.right + '</a>';
        drop.hidden = false; input.setAttribute('aria-expanded', 'true'); sel = -1;
      };
      var run = function (q) {
        if (ctrl && ctrl.abort) ctrl.abort();
        ctrl = W.AbortController ? new AbortController() : null;
        var url = ajax(R.predictive || '/search/suggest', '.json') + '?q=' + encodeURIComponent(q) +
          '&resources%5Btype%5D=product&resources%5Blimit%5D=6&resources%5Boptions%5D%5Bunavailable_products%5D=last';
        fetch(url, { signal: ctrl ? ctrl.signal : undefined, headers: { Accept: 'application/json' } })
          .then(function (r) { if (!r.ok) throw new Error(String(r.status)); return r.json(); })
          .then(function (d) {
            if (q !== lastQ) return;
            var ps = (d && d.resources && d.resources.results && d.resources.results.products) || [];
            render(q, ps);
          })
          .catch(function (err) {
            if (err && err.name === 'AbortError') return;
            drop.innerHTML = '<p class="vf-sug-empty">Vorschläge gerade nicht verfügbar.</p><a class="vf-sug-all" href="' + esc(allUrl(q)) + '">Suchen nach „' + esc(q) + '“' + ICON.right + '</a>';
            drop.hidden = false; input.setAttribute('aria-expanded', 'true');
          });
      };
      input.addEventListener('input', function () {
        var q = input.value.trim(); lastQ = q; clearTimeout(timer);
        if (q.length < 2) { close(); return; }
        timer = setTimeout(function () { run(q); }, 220);
      });
      input.addEventListener('keydown', function (e) {
        var o = opts();
        if (e.key === 'ArrowDown' && o.length) { e.preventDefault(); mark(Math.min(o.length - 1, sel + 1)); }
        else if (e.key === 'ArrowUp' && o.length) { e.preventDefault(); mark(Math.max(0, sel - 1)); }
        else if (e.key === 'Enter' && sel >= 0 && o[sel]) { e.preventDefault(); W.location.href = o[sel].href; }
        else if (e.key === 'Escape' && !drop.hidden) { e.stopPropagation(); close(); }
      });
      input.addEventListener('focus', function () { if (drop.innerHTML && input.value.trim().length >= 2) { drop.hidden = false; input.setAttribute('aria-expanded', 'true'); } });
      form.addEventListener('focusout', function (e) { if (!form.contains(e.relatedTarget)) setTimeout(function () { if (!form.contains(D.activeElement)) close(); }, 150); });
    });
  }

  /* ---------- Warenkorb (Shopify Ajax API) */
  var Cart = {
    data: null,
    req: function (url, body) {
      var o = { headers: { Accept: 'application/json' } };
      if (body) { o.method = 'POST'; o.headers['Content-Type'] = 'application/json'; o.body = JSON.stringify(body); }
      return fetch(url, o).then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (d) {
          if (!r.ok) { var e = new Error(d.description || d.message || 'Das hat leider nicht geklappt. Bitte versuch es nochmal.'); e.status = r.status; throw e; }
          return d;
        });
      });
    },
    get: function () { var self = this; return this.req(ajax(R.cart || '/cart')).then(function (d) { self.data = d; self.sync(); return d; }); },
    add: function (items) { var self = this; return this.req(ajax(R.cartAdd || '/cart/add'), { items: items }).then(function () { return self.get(); }).then(function (d) { bump(); return d; }); },
    change: function (key, qty) {
      var self = this;
      return this.req(ajax(R.cartChange || '/cart/change'), { id: key, quantity: qty })
        .then(function (d) { self.data = d; self.sync(); return d; })
        .catch(function (e) { toast(e.message); return self.get(); });
    },
    sync: function () {
      var c = this.data; if (!c) return;
      $$('[data-cart-count]').forEach(function (el) { el.textContent = c.item_count; el.hidden = !c.item_count; });
      $$('[data-cart-count-plain]').forEach(function (el) { el.textContent = c.item_count; });
      $$('[data-cart-heading-count]').forEach(function (el) { el.textContent = c.item_count ? '(' + c.item_count + ')' : ''; });
      renderDrawer(c);
    },
    after: function (opener) {
      if (VF.cartType === 'page') { W.location.href = R.cart || '/cart'; return; }
      openCart(opener, true);
    }
  };
  function bump() { $$('[data-cart-count]').forEach(function (el) { el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump'); }); }
  function upsellHtml(c) {
    var tpl = $('[data-upsell-tpl]'); if (!tpl || !tpl.content) return '';
    var inCart = (c.items || []).map(function (it) { return String(it.product_id); });
    var picks = Array.prototype.slice.call(tpl.content.querySelectorAll('.vf-up'))
      .filter(function (u) { return inCart.indexOf(u.getAttribute('data-pid')) < 0; }).slice(0, 2);
    if (!picks.length) return '';
    var title = c.item_count ? (tpl.getAttribute('data-title') || 'Passt dazu') : 'Im Fokus';
    return '<div class="vf-upsell"><p class="vf-upsell__k">' + esc(title) + '</p>' + picks.map(function (u) { return u.outerHTML; }).join('') + '</div>';
  }
  function renderDrawer(c) {
    var body = $('[data-cart-body]'), foot = $('[data-cart-foot]');
    if (!body) return;
    if (!c.item_count) {
      body.innerHTML = '<div class="vf-cart-empty">' + ICON.bag + '<p>Dein Warenkorb ist leer.</p><a class="vf-btn" href="' + esc(R.all || '/collections/all') + '">Bundles ansehen</a></div>' + upsellHtml(c);
      if (foot) foot.hidden = true;
      return;
    }
    body.innerHTML = c.items.map(function (it) {
      var img = (it.featured_image && it.featured_image.url) || it.image;
      var vt = it.product_has_only_default_variant ? '' : (it.variant_title || '');
      var old = it.original_line_price > it.final_line_price ? '<s>' + money(it.original_line_price) + '</s>' : '';
      return '<div class="vf-line" data-key="' + esc(it.key) + '">' +
        '<a class="vf-line__img" href="' + esc(it.url) + '" tabindex="-1">' + (img ? '<img src="' + esc(sized(img, 240)) + '" alt="' + esc(it.product_title) + '" width="84" height="105" loading="lazy">' : '') + '</a>' +
        '<div><div class="vf-line__top"><a href="' + esc(it.url) + '">' + esc(it.product_title) + '</a><span class="vf-line__price">' + money(it.final_line_price) + old + '</span></div>' +
        '<p class="vf-line__meta">' + (vt ? esc(vt) + ' · ' : '') + money(it.final_price) + ' pro Bundle</p>' +
        '<div class="vf-line__bot"><span class="vf-qty"><button type="button" data-cq="-1" aria-label="Weniger">−</button>' +
        '<input type="number" min="0" max="99" inputmode="numeric" value="' + it.quantity + '" aria-label="Anzahl ' + esc(it.product_title) + '" data-cq-in>' +
        '<button type="button" data-cq="1" aria-label="Mehr">+</button></span>' +
        '<button type="button" class="vf-line__rm" data-cq-rm>Entfernen</button></div></div></div>';
    }).join('') + upsellHtml(c);
    var tot = $('[data-cart-total]'); if (tot) tot.textContent = money(c.total_price);
    var fr = $('[data-cart-free]'), fs = Number(VF.freeShip) || 0;
    if (fr) {
      if (fs > 0) {
        var rest = fs - c.total_price, pct = clamp(c.total_price / fs) * 100;
        fr.innerHTML = '<div class="vf-free">' + (rest > 0 ? 'Noch <b>' + money(rest) + '</b> bis zum kostenlosen Versand' : 'Kostenloser Versand ist freigeschaltet.') +
          '<i><b style="--w:' + pct.toFixed(1) + '%"></b></i></div>';
      } else fr.innerHTML = '';
    }
    if (foot) foot.hidden = false;
  }
  function openCart(opener, fresh) {
    var dr = $('[data-cart-drawer]'); if (!dr) { W.location.href = R.cart || '/cart'; return; }
    if (!Cart.data) { var b = $('[data-cart-body]'); if (b && !b.innerHTML) b.innerHTML = '<p class="vf-sug-empty" style="padding:30px 0">Warenkorb wird geladen …</p>'; }
    showLayer(dr, opener);
    if (!fresh || !Cart.data) Cart.get().catch(function () { toast('Warenkorb konnte nicht geladen werden.'); });
  }
  function lineChange(line, qty) {
    if (!line || line.classList.contains('is-busy')) return;
    line.classList.add('is-busy');
    Cart.change(line.getAttribute('data-key'), Math.max(0, qty)).then(function () { line.classList.remove('is-busy'); });
  }
  function quickAdd(btn) {
    if (btn.classList.contains('is-busy')) return;
    btn.classList.add('is-busy');
    Cart.add([{ id: Number(btn.getAttribute('data-quick-add')), quantity: 1 }]).then(function () {
      btn.classList.remove('is-busy'); btn.classList.add('is-done');
      setTimeout(function () { btn.classList.remove('is-done'); }, 1600);
      Cart.after(btn);
    }).catch(function (e) { btn.classList.remove('is-busy'); toast(e.message); });
  }

  /* ---------- Produktseite */
  function initProduct(root) {
    $$('[data-product]', root).forEach(function (sec) {
      if (sec._vf) return; sec._vf = 1;
      var vs = []; try { vs = JSON.parse(($('[data-variants]', sec) || {}).textContent || '[]'); } catch (e) { vs = []; }
      var wrap = sec.parentElement || D;
      var form = $('[data-pform]', sec), vid = $('[data-vid]', sec), add = $('[data-add]', sec), addL = $('[data-add-label]', sec), msg = $('[data-msg]', sec);
      var priceEl = $('.vf-price-row [data-price]', sec), cmpEl = $('[data-compare]', sec), unitEl = $('[data-unit]', sec), badge = $('[data-sale-badge]', sec);
      var stock = $('[data-stock]', sec), stockT = $('[data-stock-text]', sec), calc = $('[data-calc]', sec);
      var sticky = $('[data-sticky]', wrap), sPrice = $('[data-sticky-price]', wrap), sAdd = $('[data-sticky-add]', wrap);
      var cur = vs.filter(function (v) { return vid && String(v.id) === vid.value; })[0] || vs[0];
      var low = Number(VF.lowStock) || 0;
      var label = function (v) { return v && v.avail ? 'In den Warenkorb' : 'Ausverkauft'; };
      function select(id) {
        var v = vs.filter(function (x) { return String(x.id) === String(id); })[0]; if (!v) return;
        cur = v;
        if (vid && vid.value !== String(v.id)) { vid.value = v.id; try { vid.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {} }
        var xp = $('[data-xpay]', sec); if (xp) xp.hidden = !v.avail;
        if (priceEl) priceEl.textContent = money(v.price);
        var sale = v.cmp > v.price;
        if (cmpEl) { cmpEl.hidden = !sale; cmpEl.textContent = sale ? money(v.cmp) : ''; }
        var saveEl = $('[data-save]', sec);
        if (saveEl) { saveEl.hidden = !sale; saveEl.textContent = sale ? 'Du sparst ' + money(v.cmp - v.price) : ''; }
        if (badge) { badge.hidden = !sale; if (sale) badge.textContent = 'Sale −' + Math.floor((v.cmp - v.price) * 100 / v.cmp) + ' %'; }
        if (unitEl) {
          unitEl.hidden = !v.unit;
          if (v.unit) unitEl.textContent = 'nur ' + money(v.unit.p) + '/' + (Number(v.unit.rv) !== 1 ? v.unit.rv + ' ' : '') + v.unit.ru;
        }
        if (stock && stockT) {
          var st = 'ok', tx = stock.getAttribute('data-in') || '';
          if (!v.avail) { st = 'out'; tx = 'Ausverkauft – bald wieder da'; }
          else if (low > 0 && v.qty != null && v.qty <= low) { st = 'low'; tx = 'Nur noch ' + v.qty + (v.qty === 1 ? ' Bundle' : ' Bundles') + ' verfügbar'; }
          stock.className = 'vf-stock is-' + st; stockT.textContent = tx;
        }
        if (add) { add.disabled = !v.avail; if (addL) addL.textContent = label(v); }
        if (sAdd) { sAdd.disabled = !v.avail; sAdd.textContent = label(v); }
        if (sPrice) sPrice.textContent = money(v.price);
        if (calc) { calc.setAttribute('data-price', v.price); if (v.unit && v.unit.q) calc.setAttribute('data-qty', v.unit.q); calcRun(); }
        if (vs.length > 1 && W.history && history.replaceState) {
          try { var u = new URL(W.location.href); u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u.toString()); } catch (e) {}
        }
      }
      $$('[data-tier]', sec).forEach(function (r) { r.addEventListener('change', function () { if (r.checked) select(r.value); }); });
      // Menge
      var qty = $('[data-qty] input', sec);
      $$('[data-step]', sec).forEach(function (b) {
        b.addEventListener('click', function () {
          if (!qty) return;
          qty.value = clamp((parseInt(qty.value, 10) || 1) + Number(b.getAttribute('data-step')), 1, 99);
        });
      });
      if (qty) qty.addEventListener('change', function () { qty.value = clamp(parseInt(qty.value, 10) || 1, 1, 99); });
      // In den Warenkorb
      if (form) form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!add || add.disabled || add.classList.contains('is-busy')) return;
        var n = clamp(parseInt(qty && qty.value, 10) || 1, 1, 99);
        add.classList.add('is-busy'); if (addL) addL.textContent = 'Wird hinzugefügt …'; if (msg) msg.textContent = '';
        Cart.add([{ id: Number(vid.value), quantity: n }]).then(function () {
          if (addL) addL.textContent = 'Hinzugefügt ✓';
          Cart.after(add);
        }).catch(function (err) { if (msg) msg.textContent = err.message; })
          .then(function () { setTimeout(function () { add.classList.remove('is-busy'); if (addL) addL.textContent = label(cur); }, 1300); });
      });
      // Leiste unten (Handy)
      if (sticky && form && 'IntersectionObserver' in W) {
        var io = new IntersectionObserver(function (es) {
          var en = es[0], on = !en.isIntersecting && en.boundingClientRect.top < 0;
          sticky.classList.toggle('is-on', on); sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
          if (sAdd) sAdd.tabIndex = on ? 0 : -1;
        });
        io.observe(form);
        if (sAdd) sAdd.addEventListener('click', function () {
          if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true }));
        });
      }
      // Galerie (Handy: wischen, Punkte + Zähler)
      var track = $('[data-gal-track]', sec), dots = $$('.vf-gal__dots i', sec), cnt = $('[data-gal-i]', sec);
      if (track && (dots.length || cnt)) {
        var gi = 0;
        track.addEventListener('scroll', function () {
          var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
          if (i === gi) return; gi = i;
          dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
          if (cnt) cnt.textContent = i + 1;
        }, { passive: true });
      }
      // Gewinnrechner
      function calcRun() {
        if (!calc) return;
        var inp = $('[data-calc-in]', calc); if (!inp) return;
        var each = Number(inp.value) * 100, q = Number(calc.getAttribute('data-qty')) || 1, price = Number(calc.getAttribute('data-price')) || 0;
        var set = function (s, v) { var el = $(s, calc); if (el) el.textContent = v; };
        set('[data-calc-out]', money(each));
        set('[data-calc-buy]', money(Math.round(price / q)));
        set('[data-calc-sell]', money(each * q));
        set('[data-calc-win]', money(each * q - price));
        var range = Number(inp.max) - Number(inp.min) || 1;
        inp.style.setProperty('--fill', ((Number(inp.value) - Number(inp.min)) / range * 100).toFixed(1) + '%');
      }
      if (calc) { var ci = $('[data-calc-in]', calc); if (ci) ci.addEventListener('input', calcRun); calcRun(); }
    });
  }

  /* ---------- Bild-Großansicht */
  var lb = null;
  function openLb(btn) {
    var gal = btn.closest('[data-gallery]'); if (!gal) return;
    var items = $$('[data-lb]', gal), i = Math.max(0, items.indexOf(btn));
    var srcs = items.map(function (x) { return x.getAttribute('data-full'); });
    var alts = items.map(function (x) { var im = $('img', x); return im ? im.alt : ''; });
    if (lb) closeLb(true);
    var el = D.createElement('div');
    el.className = 'vf-lb'; el.setAttribute('role', 'dialog'); el.setAttribute('aria-modal', 'true'); el.setAttribute('aria-label', 'Bildansicht');
    el.innerHTML = '<img alt="">' +
      '<button class="vf-lb__btn vf-lb__close" type="button" aria-label="Schließen">' + ICON.close + '</button>' +
      (srcs.length > 1 ? '<button class="vf-lb__btn vf-lb__prev" type="button" aria-label="Vorheriges Bild">' + ICON.left + '</button>' +
        '<button class="vf-lb__btn vf-lb__next" type="button" aria-label="Nächstes Bild">' + ICON.right + '</button><span class="vf-lb__count" aria-live="polite"></span>' : '');
    D.body.appendChild(el); lock(true);
    var img = $('img', el), cnt = $('.vf-lb__count', el);
    var show = function (k) { i = (k + srcs.length) % srcs.length; img.src = srcs[i]; img.alt = alts[i]; if (cnt) cnt.textContent = (i + 1) + ' / ' + srcs.length; };
    show(i);
    lb = { el: el, show: show, i: function () { return i; }, opener: btn };
    void el.offsetWidth; el.classList.add('is-open');
    el.addEventListener('click', function (e) {
      if (e.target.closest('.vf-lb__close') || e.target === el) closeLb();
      else if (e.target.closest('.vf-lb__prev')) show(i - 1);
      else if (e.target.closest('.vf-lb__next')) show(i + 1);
    });
    var sx = null;
    el.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    el.addEventListener('touchend', function (e) {
      if (sx == null) return; var dx = e.changedTouches[0].clientX - sx; sx = null;
      if (Math.abs(dx) > 50 && srcs.length > 1) show(i + (dx < 0 ? 1 : -1));
    });
    $('.vf-lb__close', el).focus({ preventScroll: true });
  }
  function closeLb(silent) {
    if (!lb) return;
    var o = lb; lb = null;
    o.el.classList.remove('is-open');
    setTimeout(function () { o.el.remove(); }, 320);
    if (!layer) lock(false);
    if (!silent && o.opener) o.opener.focus({ preventScroll: true });
  }

  /* ---------- Karusselle (Pfeile + Fortschritt) */
  function sectionOf(el) { return el.closest('[data-section]') || el.closest('.shopify-section') || D.body; }
  function visibleRail(sec) { return $$('[data-rail]', sec).filter(function (r) { return r.offsetParent !== null; })[0]; }
  function updateRail(rail) {
    var track = $('[data-rail-track]', rail); if (!track) return;
    var max = track.scrollWidth - track.clientWidth;
    var scope = rail.closest('[data-panel]') || sectionOf(rail);
    var bar = $('[data-rail-bar]', scope);
    var w = track.scrollWidth ? Math.min(1, track.clientWidth / track.scrollWidth) : 1;
    var prog = max > 0 ? clamp(track.scrollLeft / max) : 0;
    if (bar) {
      bar.style.setProperty('--w', (w * 100).toFixed(2) + '%');
      bar.style.setProperty('--x', (w < 1 ? (1 - w) / w * prog * 100 : 0).toFixed(2) + '%');
      if (bar.parentElement) bar.parentElement.hidden = max <= 2;
    }
    if (rail.offsetParent === null) return;
    var arr = $('[data-rail-arrows]', sectionOf(rail));
    if (arr) {
      arr.hidden = max <= 2;
      var p = $('[data-rail-prev]', arr), n = $('[data-rail-next]', arr);
      if (p) p.disabled = track.scrollLeft <= 2;
      if (n) n.disabled = track.scrollLeft >= max - 2;
    }
  }
  function initRails(root) {
    $$('[data-rail]', root).forEach(function (rail) {
      var track = $('[data-rail-track]', rail);
      if (!track || rail._vf) return; rail._vf = 1;
      var raf = 0;
      var idle = 0;
      track.addEventListener('scroll', function () {
        if (!raf) raf = requestAnimationFrame(function () { raf = 0; updateRail(rail); });
        if (!track.classList.contains('is-scrolling')) track.classList.add('is-scrolling');
        clearTimeout(idle); idle = setTimeout(function () { track.classList.remove('is-scrolling'); }, 180);
      }, { passive: true });
      updateRail(rail);
    });
  }
  function updateAllRails() { $$('[data-rail]').forEach(updateRail); }

  /* ---------- Reiter (Reseller Bundles) */
  function initTabs(root) {
    $$('[data-tabs]', root).forEach(function (sec) {
      if (sec._vf) return; sec._vf = 1;
      var tabs = $$('[data-tab]', sec), panels = $$('[data-panel]', sec);
      var select = function (i, focus) {
        if (!tabs[i]) return;
        tabs.forEach(function (t, k) { t.setAttribute('aria-selected', k === i ? 'true' : 'false'); t.tabIndex = k === i ? 0 : -1; });
        panels.forEach(function (p, k) { p.hidden = k !== i; });
        if (focus) tabs[i].focus();
        var rail = panels[i] && $('[data-rail]', panels[i]);
        if (rail) { var tr = $('[data-rail-track]', rail); if (tr) tr.scrollLeft = 0; updateRail(rail); }
        tabs[i].scrollIntoView({ block: 'nearest', inline: 'nearest' });
      };
      sec._select = select;
      sec.addEventListener('click', function (e) { var t = e.target.closest('[data-tab]'); if (t) select(tabs.indexOf(t)); });
      sec.addEventListener('keydown', function (e) {
        var t = e.target.closest('[data-tab]'); if (!t) return;
        var i = tabs.indexOf(t), n = tabs.length;
        if (e.key === 'ArrowRight') i = (i + 1) % n; else if (e.key === 'ArrowLeft') i = (i - 1 + n) % n;
        else if (e.key === 'Home') i = 0; else if (e.key === 'End') i = n - 1; else return;
        e.preventDefault(); select(i, true);
      });
    });
  }

  /* ---------- Hinweise oben (ruhige Fassung): ein Hinweis nach dem anderen, sanft überblendet, pausiert bei Maus/Fokus */
  function initAnnFade(root) {
    $$('[data-ann-fade]', root).forEach(function (bar) {
      if (bar._vf) return; bar._vf = 1;
      var msgs = $$('[data-ann-msg]', bar), i = 0, t = 0, hold = false;
      if (msgs.length < 2) return;
      var ms = Math.max(3, Number(bar.getAttribute('data-interval')) || 4) * 1000;
      var show = function (k) { i = (k + msgs.length) % msgs.length; msgs.forEach(function (m, n) { m.classList.toggle('is-on', n === i); }); };
      var tick = function () { clearTimeout(t); t = setTimeout(function () { if (!hold && !D.hidden) show(i + 1); tick(); }, ms); };
      // nur echte Maus pausiert (ein Tippen am Handy soll das Wechseln nicht anhalten)
      bar.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') hold = true; });
      bar.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') hold = false; });
      bar.addEventListener('focusin', function () { hold = true; });
      bar.addEventListener('focusout', function () { hold = false; });
      // Theme-Editor: gewählten Hinweis zeigen
      D.addEventListener('shopify:block:select', function (e) { var k = msgs.indexOf(e.target); if (k >= 0) { show(k); hold = true; } });
      D.addEventListener('shopify:block:deselect', function () { hold = false; });
      tick();
    });
  }

  /* ---------- Laufbänder: genug Wiederholungen für jede Breite, gleiches Tempo */
  function initMarquee(root) {
    $$('[data-marquee]', root).forEach(function (m) {
      var track = $('[data-marquee-track]', m), groups = $$('[data-marquee-group]', m);
      if (!track || groups.length < 2) return;
      if (!m._orig) m._orig = Array.prototype.slice.call(groups[0].children).map(function (c) { return c.cloneNode(true); });
      // Tempo bleibt gleich: Dauer wächst mit der Zahl der Wiederholungen
      var base = parseFloat(getComputedStyle(m).getPropertyValue('--dur')) || 40, n = 0;
      m._copies = m._copies || 1;
      while (groups[0].scrollWidth < m.clientWidth + 60 && n++ < 16) {
        groups.forEach(function (g) {
          m._orig.forEach(function (c) {
            var x = c.cloneNode(true); x.setAttribute('aria-hidden', 'true');
            $$('a', x).forEach(function (a) { a.tabIndex = -1; });
            if (x.tagName === 'A') x.tabIndex = -1;
            g.appendChild(x);
          });
        });
        m._copies++;
      }
      if (m._copies > 1) track.style.setProperty('--dur', (base * m._copies).toFixed(1) + 's');
    });
  }

  /* ---------- Vorteile: am Handy nacheinander */
  function initUsp(root) {
    $$('[data-usp]', root).forEach(function (u) {
      if (u._t) clearInterval(u._t);
      if (u.classList.contains('vf-usp--light')) return;   // große Fläche zeigt alles, schlanke/dunkle Leiste wechselt am Handy durch
      var items = $$('.vf-usp__item', u); if (items.length < 2) return;
      var i = Math.max(0, items.findIndex(function (x) { return x.classList.contains('is-on'); }));
      u._t = setInterval(function () {
        if (!u.isConnected) { clearInterval(u._t); return; }
        if (!mq('(max-width: 749px)').matches || D.hidden) return;
        items[i].classList.remove('is-on'); i = (i + 1) % items.length; items[i].classList.add('is-on');
      }, 3200);
    });
  }

  /* ---------- Einblenden beim Scrollen + Zahlen hochzählen */
  var revealIO = null;
  function countUp(el) {
    var txt = (el.textContent || '').trim(), m = txt.match(/^(\d{1,4})(\s+[A-Za-zÄÖÜäöüß.]+)?$/);
    if (!m || REDUCE) return;
    var to = Number(m[1]), suf = m[2] || '', t0 = 0;
    var step = function (now) {
      if (!t0) t0 = now;
      var p = clamp((now - t0) / 1100), e = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(to * e) + suf;
      if (p < 1) requestAnimationFrame(step); else el.textContent = txt;
    };
    el.textContent = '0' + suf;
    requestAnimationFrame(step);
  }
  // Sicherheitsnetz zum Beobachter: beim schnellen Scrollen übersprungene Elemente (schon oberhalb) und alles,
  // was ganz unten auf der Seite steht und den Beobachter nie ganz erreicht, wird sofort gezeigt.
  var revealPending = [], revealT = 0;
  var revealTrail = 0;
  function revealPast(trail) {
    if (!revealPending.length) return;
    var now = Date.now();
    if (trail !== true) {
      clearTimeout(revealTrail); revealTrail = setTimeout(function () { revealPast(true); }, 220);   // nach dem letzten Scrollen noch einmal prüfen
      if (now - revealT < 180) return;
    }
    revealT = now;
    var vh = W.innerHeight, end = W.pageYOffset + vh >= D.documentElement.scrollHeight - 4;
    revealPending = revealPending.filter(function (el) {
      if (el.classList.contains('is-in') || !el.isConnected) return false;
      var r = el.getBoundingClientRect();
      if ((r.width || r.height) && (r.bottom < 0 || (end && r.top < vh))) {
        el.classList.add('is-in'); if (revealIO) revealIO.unobserve(el);
        if (el.hasAttribute('data-count') && r.bottom >= 0) countUp(el);
        return false;
      }
      return true;
    });
  }
  // Karussells: alle Karten einer Schiene erscheinen gemeinsam, sobald die Schiene ins Bild kommt.
  // Karten rechts außerhalb stehen sofort fertig da – beim Wischen nach rechts bewegt sich nichts mehr.
  function revealTrack(track) {
    var tr = track.getBoundingClientRect();
    $$('[data-reveal]:not(.is-in)', track).forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.right <= tr.left + 1 || r.left >= tr.right - 1) {
        el.style.transition = 'none'; el.classList.add('is-in'); void el.offsetWidth; el.style.transition = '';
      } else el.classList.add('is-in');
    });
  }
  var trackIO = null;
  function initReveal(root) {
    var els = $$('[data-reveal]:not(.is-in),[data-ft-mark]:not(.is-in),[data-count]:not(.is-in)', root);
    if (!('IntersectionObserver' in W) || !ANIM) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    if (!revealIO) revealIO = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (!en.isIntersecting) return;
        var t = en.target; t.classList.add('is-in'); revealIO.unobserve(t);
        if (t.hasAttribute('data-count')) countUp(t);
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
    if (!trackIO) trackIO = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (en.isIntersecting) { revealTrack(en.target); trackIO.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.04 });
    var single = els.filter(function (e) { return !e.closest('[data-rail-track]'); });
    single.forEach(function (e) { revealIO.observe(e); });
    $$('[data-rail-track]', root).forEach(function (t) { if ($('[data-reveal]:not(.is-in)', t)) trackIO.observe(t); });
    revealPending = revealPending.concat(single);
  }

  /* ---------- Liefertermin: „Voraussichtlich bei dir: Mo., 19.10. – Mi., 21.10.“ */
  function addDays(d, n, workdays) {
    var x = new Date(d.getTime());
    if (!workdays) { x.setDate(x.getDate() + n); return x; }
    while (n > 0) { x.setDate(x.getDate() + 1); var wd = x.getDay(); if (wd !== 0 && wd !== 6) n--; }
    return x;
  }
  function initEta(root) {
    $$('[data-eta]', root).forEach(function (el) {
      var t = $('[data-eta-text]', el); if (!t) return;
      var a = Number(el.getAttribute('data-min')) || 5, b = Number(el.getAttribute('data-max')) || 7, wd = el.getAttribute('data-bd') === '1';
      if (b < a) { var z = a; a = b; b = z; }
      var now = new Date(), d1 = addDays(now, a, wd), d2 = addDays(now, b, wd);
      var f = function (d) {
        try { return new Intl.DateTimeFormat('de-DE', { weekday: 'short', day: '2-digit', month: '2-digit' }).format(d); }
        catch (e) { return d.getDate() + '.' + (d.getMonth() + 1) + '.'; }
      };
      t.innerHTML = 'Voraussichtlich bei dir: <b>' + esc(f(d1)) + (a !== b ? ' – ' + esc(f(d2)) : '') + '</b>';
    });
  }

  /* ---------- Texte einblenden: Überschriften Wort für Wort, großer Satz färbt sich beim Scrollen ein */
  function splitWords(el, cls) {
    var i = 0;
    var walk = function (node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (n) {
        if (n.nodeType === 3) {
          var frag = D.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach(function (w) {
            if (!w) return;
            if (/^\s+$/.test(w)) { frag.appendChild(D.createTextNode(' ')); return; }
            var o = D.createElement('span'); o.className = cls;
            if (cls === 'vf-w') { var inner = D.createElement('span'); inner.textContent = w; inner.style.setProperty('--wi', i); o.appendChild(inner); }
            else { o.textContent = w; o.style.setProperty('--wi', i); }
            i++; frag.appendChild(o);
          });
          n.parentNode.replaceChild(frag, n);
        } else if (n.nodeType === 1 && !n.classList.contains(cls)) walk(n);
      });
    };
    walk(el);
    return i;
  }
  var stmts = [];
  function initWords(root) {
    if (!ANIM) return;
    $$('.vf-h2, .vf-colhead .vf-h1, .vf-page__title, .vf-spin__head .vf-h2', root).forEach(function (h) {
      if (h._split || h.closest('[data-hero]')) return; h._split = 1;
      splitWords(h, 'vf-w');
      if (revealIO && !h.closest('[data-reveal]')) { revealIO.observe(h); revealPending.push(h); }
      else if (!revealIO) h.classList.add('is-in');
    });
    $$('[data-words]', root).forEach(function (el) {
      if (el._split) return; el._split = 1;
      el._n = splitWords(el, 'vf-sw'); el._lit = -1;
      el._words = $$('.vf-sw', el);
      el.classList.add('is-split');
      stmts.push(el);
    });
    stmts = stmts.filter(function (el) { return el.isConnected; });
  }
  function litWords() {
    if (!stmts.length) return;
    var vh = W.innerHeight;
    stmts.forEach(function (el) {
      var r = el.getBoundingClientRect(); if (r.bottom < -100 || r.top > vh + 100) return;
      // startet, wenn der Satz unten ins Bild kommt; ganz eingefärbt, sobald er etwa mittig steht
      var p = clamp((vh * 0.85 - r.top) / (r.height + vh * 0.23));
      var n = Math.round(p * el._n); if (n === el._lit) return;
      el._lit = n;
      el._words.forEach(function (w, k) { w.classList.toggle('is-lit', k < n); });
    });
  }

  /* ---------- Hauptbanner: Start-Animation */
  function initHero(root) {
    $$('[data-hero]', root).forEach(function (h) {
      var img = $('[data-hero-media] img', h), done = false;
      var ready = function () { if (done) return; done = true; requestAnimationFrame(function () { h.classList.add('is-ready'); }); };
      if (!img || img.complete) ready();
      else { img.addEventListener('load', ready, { once: true }); img.addEventListener('error', ready, { once: true }); setTimeout(ready, 1400); }
    });
  }

  /* ---------- Footer: Markenname füllt genau die Breite */
  function fitWords(root) {
    $$('.vf-ft__word', root).forEach(function (el) {
      var box = el.parentElement; if (!box) return;
      el.style.fontSize = '';
      var avail = box.clientWidth; if (!avail) return;
      el.style.width = 'max-content'; el.style.justifyContent = 'flex-start';
      var nat = el.scrollWidth, fs = parseFloat(getComputedStyle(el).fontSize);
      el.style.width = ''; el.style.justifyContent = '';
      if (nat > 0 && fs > 0) el.style.fontSize = Math.min(fs * avail / nat * 0.995, 420).toFixed(2) + 'px';
    });
  }

  /* ---------- Kollektion: Sortierung, Ansicht, Filter */
  function store(k, v) { try { if (v === undefined) return W.localStorage.getItem(k); W.localStorage.setItem(k, v); } catch (e) { return null; } return null; }
  function applyView(grid, cols) {
    if (!grid) return;
    if (cols === '1') grid.classList.add('is-one'); if (cols === '2') grid.classList.remove('is-one');
    if (cols === '3') grid.classList.add('is-c3'); if (cols === '4') grid.classList.remove('is-c3');
  }
  function initCollection(root) {
    $$('[data-sort]', root).forEach(function (s) {
      if (s._vf) return; s._vf = 1;
      s.addEventListener('change', function () {
        try { var u = new URL(W.location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page'); W.location.href = u.toString(); }
        catch (e) { W.location.search = '?sort_by=' + encodeURIComponent(s.value); }
      });
    });
    $$('[data-view]', root).forEach(function (v) {
      if (v._vf) return; v._vf = 1;
      var grid = $('[data-grid]', v.closest('.shopify-section') || D);
      var mark = function (cols) {
        var mobile = cols === '1' || cols === '2';
        $$('[data-cols]', v).forEach(function (b) {
          var bm = b.getAttribute('data-cols') === '1' || b.getAttribute('data-cols') === '2';
          if (bm === mobile) b.setAttribute('aria-pressed', b.getAttribute('data-cols') === cols ? 'true' : 'false');
        });
      };
      ['vf-view-m', 'vf-view-d'].forEach(function (k) { var c = store(k); if (c) { applyView(grid, c); mark(c); } });
      v.addEventListener('click', function (e) {
        var b = e.target.closest('[data-cols]'); if (!b) return;
        var c = b.getAttribute('data-cols');
        applyView(grid, c); mark(c);
        store(c === '1' || c === '2' ? 'vf-view-m' : 'vf-view-d', c);
      });
    });
    $$('[data-filter-form]', root).forEach(function (f) {
      if (f._vf) return; f._vf = 1;
      f.addEventListener('submit', function () {
        $$('input', f).forEach(function (i) { if ((i.type === 'number' || i.type === 'text') && !i.value) i.disabled = true; });
      });
    });
  }

  /* ---------- Warenkorb-Seite: Menge ändern → automatisch aktualisieren */
  function initCartPage(root) {
    $$('[data-cartpage]', root).forEach(function (f) {
      if (f._vf) return; f._vf = 1;
      var t = 0, upd = (f.elements && f.elements.namedItem && f.elements.namedItem('update')) || $('[name=update]', f);   // Button steht per form= außerhalb
      var go = function () { clearTimeout(t); t = setTimeout(function () { if (f.requestSubmit && upd) f.requestSubmit(upd); else if (upd) upd.click(); }, 650); };
      f.addEventListener('click', function (e) {
        var b = e.target.closest('[data-q]'); if (!b) return;
        var inp = $('input', b.parentElement); if (!inp) return;
        inp.value = Math.max(0, (parseInt(inp.value, 10) || 0) + Number(b.getAttribute('data-q')));
        go();
      });
      f.addEventListener('change', function (e) { if (e.target.matches('input[name="updates[]"]')) go(); });
    });
  }

  /* ---------- 360°-Ansicht */
  var scripts = {}, spins = [], spinRaf = 0, PITCH = 0.07, TURN = Math.PI * 2;
  function loadJS(src) {
    if (!src) return Promise.reject(new Error('ohne Quelle'));
    if (!scripts[src]) scripts[src] = new Promise(function (res, rej) {
      var s = D.createElement('script'); s.src = src; s.async = true; s.onload = res; s.onerror = rej; D.head.appendChild(s);
    });
    return scripts[src];
  }
  function spinMount(S, i) {
    if (S.dead || S.views[i] !== null || !W.X3D) return;
    var it = S.items[i], data = W.X3D_DATA && W.X3D_DATA[it.getAttribute('data-prod')];
    if (!data) { S.views[i] = false; return; }
    var cv = D.createElement('canvas'); cv.setAttribute('aria-hidden', 'true'); it.appendChild(cv);
    var v = W.X3D(cv, data, it.getAttribute('data-tex'), { fill: 0.84, maxDpr: W.innerWidth < 900 ? 2 : 2.5 });
    if (!v || !v.gl) { cv.remove(); S.views[i] = false; return; }
    S.views[i] = v; S.cvs[i] = cv;
    v.ready(function () { if (S.dead) return; it.classList.add('is-live'); S.lastDeg = null; spinKick(); });
  }
  // Link unten: zeigt auf das aktive Teil, wenn es einen eigenen Link hat (z. B. Produkt „Mystery Box“), sonst auf den Standard
  function spinLink(S) {
    if (S.stage) S.stage.classList.toggle('has-link', !!spinHref(S));
    var ln = S.link; if (!ln) return;
    var it = S.items[S.active], href = it && it.getAttribute('data-link');
    ln.setAttribute('href', href || ln.getAttribute('data-href0'));
    if (S.linkT) S.linkT.textContent = (href && it.getAttribute('data-link-text')) || ln.getAttribute('data-text0');
  }
  function spinHref(S) { var it = S.items[S.active]; return (it && it.getAttribute('data-link')) || ''; }
  function spinActive(S, i) {
    if (i === S.active) return;
    S.active = i; spinLink(S);
    S.items.forEach(function (it, k) { it.classList.toggle('is-on', k === i); });
    S.tabs.forEach(function (t, k) { t.setAttribute('aria-selected', k === i ? 'true' : 'false'); t.tabIndex = k === i ? 0 : -1; });
    if (S.idx) S.idx.textContent = (i + 1 < 10 ? '0' : '') + (i + 1);
    S.cur = S.target; S.lastDeg = null;
    if (S.loaded) spinMount(S, i);
  }
  function spinFrame(S) {
    var seg = S.active, t = 1, moving = false;
    if (!S.static) {
      var r = S.sec.getBoundingClientRect(), range = r.height - S.pinH;
      var p = range > 0 ? clamp(-r.top / range) : 0, x = p * S.N;
      seg = Math.min(S.N - 1, Math.floor(x)); t = p >= 1 ? 1 : x - seg;
      if (S.forced >= 0) { seg = S.forced; t = 0; }
      S.target = TURN * easeIO(clamp((t - 0.08) / 0.84));
    } else S.target = 0;
    if (seg !== S.active) spinActive(S, seg);
    var a = S.active;
    // zeitbasiert glätten: gleich weich bei 30, 60 oder 120 Bildern pro Sekunde
    var now = (W.performance || Date).now(), dt = S.t ? now - S.t : 16.7; S.t = now;
    if (dt > 100 || dt <= 0) dt = 16.7;
    var f = dt / 16.7;
    if (S.glide && !S.drag) {
      S.vel *= Math.pow(0.93, f); S.d[a] += S.vel * f; S.dT[a] = S.d[a];
      if (Math.abs(S.vel) < 0.0006) S.glide = false; else moving = true;
    } else if (!S.drag && Math.abs(S.dT[a] - S.d[a]) > 0.0005) { S.d[a] += (S.dT[a] - S.d[a]) * (1 - Math.pow(0.8, f)); moving = true; }
    var diff = S.target - S.cur;
    if (Math.abs(diff) > 0.0005) { S.cur += diff * (1 - Math.pow(0.84, f)); moving = true; } else S.cur = S.target;
    var yaw = S.cur + S.d[a], deg = yaw * 180 / Math.PI;
    var v = S.views[a]; if (v) v.set(yaw, PITCH);
    if (S.lastDeg === null || Math.abs(deg - S.lastDeg) > 0.04) {
      S.lastDeg = deg;
      S.stage.style.setProperty('--yaw', (-deg).toFixed(2) + 'deg');
      S.stage.style.setProperty('--sh', (0.62 + 0.38 * Math.abs(Math.cos(yaw))).toFixed(3));
      if (S.deg) { var dd = ((Math.round(deg) % 360) + 360) % 360; S.deg.textContent = (dd < 10 ? '00' : dd < 100 ? '0' : '') + dd + '°'; }
    }
    var pk = seg + ':' + (S.static ? 1 : Math.round(t * 200));
    if (pk !== S.lastP) {
      S.lastP = pk;
      S.tabs.forEach(function (tb, k) { tb.style.setProperty('--p', S.static ? (k === seg ? 1 : 0) : (k < seg ? 1 : k === seg ? clamp(t).toFixed(3) : 0)); });
    }
    return moving || !!S.drag;
  }
  function spinTick() {
    spinRaf = 0; var again = false, vh = W.innerHeight;
    spins.forEach(function (S) {
      if (S.dead) return;
      var r = S.sec.getBoundingClientRect();
      S.vis = r.bottom > 0 && r.top < vh;
      // außerhalb des Bildschirms nichts rechnen: Schwung nach dem Wischen sofort beenden
      if (!S.vis && S.glide && !S.drag) { S.glide = false; S.vel = 0; S.dT[S.active] = S.d[S.active]; }
      if (S.vis || S.drag) { if (spinFrame(S)) again = true; else S.t = 0; }
    });
    if (again) spinKick();
  }
  function spinKick() { if (!spinRaf && spins.length) spinRaf = requestAnimationFrame(spinTick); }
  function spinDestroy(S) {
    S.dead = true;
    spins = spins.filter(function (x) { return x !== S; });
    if (S.io) S.io.disconnect(); if (S.lio) S.lio.disconnect();
    S.cvs.forEach(function (cv) {
      if (!cv) return;
      try { var gl = cv.getContext('webgl2') || cv.getContext('webgl'); var ext = gl && gl.getExtension('WEBGL_lose_context'); if (ext) ext.loseContext(); } catch (e) {}
      cv.remove();
    });
  }
  function initSpin(root) {
    $$('[data-spin]', root).forEach(function (sec) {
      if (sec._spin) spinDestroy(sec._spin);
      var stage = $('[data-spin-stage]', sec), pin = $('[data-spin-pin]', sec), items = $$('[data-spin-item]', sec);
      if (!stage || !items.length) return;
      var N = items.length;
      var S = {
        sec: sec, stage: stage, pin: pin, items: items, tabs: $$('[data-spin-tab]', sec), N: N, active: 0, forced: -1,
        views: items.map(function () { return null; }), cvs: items.map(function () { return null; }),
        d: items.map(function () { return 0; }), dT: items.map(function () { return 0; }),
        cur: 0, target: 0, vel: 0, glide: false, drag: null, vis: false, loaded: false, wanted: false, dead: false,
        static: REDUCE || !ANIM, pinH: 0, lastDeg: null, lastP: '', deg: $('[data-spin-deg]', sec), idx: $('[data-spin-i]', sec),
        link: $('[data-spin-link]', sec), linkT: $('[data-spin-link-t]', sec)
      };
      spinLink(S);
      sec._spin = S; spins.push(S);
      sec.classList.toggle('is-static', S.static);
      S.pinH = pin ? pin.offsetHeight : 0;
      // 3D erst kurz vor dem Bereich laden
      var load = function () {
        if (S.wanted) return; S.wanted = true;
        loadJS(sec.getAttribute('data-js'))
          .then(function () { return Promise.all(items.map(function (it) { return loadJS(it.getAttribute('data-djs')).catch(function () { return null; }); })); })
          .then(function () {
            if (S.dead) return; S.loaded = true;
            spinMount(S, S.active);
            setTimeout(function () { items.forEach(function (_, k) { spinMount(S, k); }); }, 450);
            spinKick();
          }).catch(function () {});
      };
      if ('IntersectionObserver' in W) {
        S.lio = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { load(); S.lio.disconnect(); } }, { rootMargin: '80% 0px' });
        S.lio.observe(sec);
        S.io = new IntersectionObserver(function (es) { S.vis = es[0].isIntersecting; if (S.vis) { S.pinH = pin ? pin.offsetHeight : 0; spinKick(); } });
        S.io.observe(sec);
      } else { load(); S.vis = true; }
      // Reiter: zum Teil springen
      var go = function (k) {
        if (S.static || S.forced >= 0) { spinActive(S, k); spinKick(); return; }
        var r = sec.getBoundingClientRect(), range = r.height - S.pinH;
        W.scrollTo({ top: W.pageYOffset + r.top + range * (k / N) + 2, behavior: REDUCE ? 'auto' : 'smooth' });
      };
      S.tabs.forEach(function (tb, k) {
        tb.addEventListener('click', function () { go(k); });
        tb.addEventListener('keydown', function (e) {
          var n = null;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') n = (k + 1) % N;
          else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') n = (k - 1 + N) % N;
          if (n === null) return;
          e.preventDefault(); S.tabs[n].focus(); go(n);
        });
      });
      // Ziehen / Wischen (nur waagerecht – senkrecht scrollt die Seite weiter)
      stage.addEventListener('pointerdown', function (e) {
        if (e.button > 0) return;
        S.drag = { x: e.clientX, y: e.clientY, d: S.d[S.active], moved: false };
        S.glide = false; S.vel = 0; S.lx = e.clientX; S.lt = (W.performance || Date).now();
      });
      stage.addEventListener('pointermove', function (e) {
        var g = S.drag; if (!g) return;
        var dx = e.clientX - g.x;
        if (!g.moved) {
          if (Math.abs(dx) < 6) return;
          if (Math.abs(e.clientY - g.y) > Math.abs(dx)) { S.drag = null; return; }
          g.moved = true; stage.classList.add('is-held', 'is-touched');
          try { stage.setPointerCapture(e.pointerId); } catch (x) {}
        }
        var now = (W.performance || Date).now(), dt = Math.max(8, now - S.lt);
        S.vel = (e.clientX - S.lx) * 0.011 * (16.7 / dt); S.lx = e.clientX; S.lt = now;
        S.d[S.active] = S.dT[S.active] = g.d + dx * 0.011;
        spinKick();
      });
      var end = function () {
        var g = S.drag; S.drag = null; stage.classList.remove('is-held');
        if (g && g.moved) { S.dragged = true; setTimeout(function () { S.dragged = false; }, 80); }
        if (g && g.moved && Math.abs(S.vel) > 0.002) { S.glide = true; spinKick(); }
      };
      stage.addEventListener('pointerup', end); stage.addEventListener('pointercancel', end); stage.addEventListener('lostpointercapture', end);
      // Antippen (ohne Ziehen) bzw. Enter: Teil mit eigenem Link öffnen (z. B. Produkt „Mystery Box“)
      stage.addEventListener('click', function (e) {
        if (S.dragged || (e.target.closest && e.target.closest('a'))) return;
        var href = spinHref(S); if (href) W.location.href = href;
      });
      stage.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' && e.target === stage) { var h2 = spinHref(S); if (h2) { W.location.href = h2; return; } }
        var s = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0; if (!s) return;
        e.preventDefault(); stage.classList.add('is-touched');
        S.dT[S.active] += s * Math.PI / 8; spinKick();
      });
      S.lastDeg = null; spinFrame(S);
    });
  }
  function spinResize() {
    spins.forEach(function (S) {
      S.pinH = S.pin ? S.pin.offsetHeight : 0;
      S.views.forEach(function (v) { if (v) v.resize(); });
      S.lastDeg = null;
    });
    spinKick();
  }

  /* ---------- Bewegung beim Scrollen: Kopfzeile, Banner, Bild mit Text */
  var ticking = false, hd = null;
  function onScroll() {
    if (ticking) return; ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      var y = W.pageYOffset, vh = W.innerHeight;
      if (hd) hd.classList.toggle('is-stuck', y > 4);
      litWords(); revealPast();
      // Banner und Bilder werden nicht mehr per Skript beim Scrollen verschoben (das ruckelte/„hing“ auf Handys).
      // Sanfte Bildbewegung bei „Bild mit Text“ übernimmt CSS (scroll-driven), nur wo der Browser es flüssig kann.
    });
    spinKick();
  }

  /* ---------- Klicks (zentral, funktioniert auch nach Neuladen von Abschnitten) */
  D.addEventListener('click', function (e) {
    var t = e.target; if (!t || !t.closest) return;
    var el;
    if ((el = t.closest('[data-drawer-open]'))) { var dr = D.getElementById(el.getAttribute('data-drawer-open')); if (dr) { e.preventDefault(); showLayer(dr, el); } return; }
    if (t.closest('[data-drawer-close]') || t.closest('[data-sheet-close]')) { e.preventDefault(); hideLayer(); return; }
    if ((el = t.closest('[data-sheet-open]'))) { e.preventDefault(); showLayer($('[data-sheet]'), el); return; }
    if ((el = t.closest('[data-cart-open]'))) {
      if (VF.cartType === 'page' || D.body.classList.contains('tpl-cart') || !$('[data-cart-drawer]')) return;
      e.preventDefault(); openCart(el); return;
    }
    if ((el = t.closest('[data-quick-add]'))) { e.preventDefault(); quickAdd(el); return; }
    if ((el = t.closest('[data-acc-tog]'))) {
      var sub = D.getElementById(el.getAttribute('aria-controls')), on = el.getAttribute('aria-expanded') !== 'true';
      el.setAttribute('aria-expanded', on ? 'true' : 'false'); if (sub) sub.hidden = !on; return;
    }
    if ((el = t.closest('[data-cq]'))) {
      var line = el.closest('.vf-line'), inp = line && $('[data-cq-in]', line);
      if (inp) lineChange(line, (parseInt(inp.value, 10) || 0) + Number(el.getAttribute('data-cq')));
      return;
    }
    if ((el = t.closest('[data-cq-rm]'))) { lineChange(el.closest('.vf-line'), 0); return; }
    if ((el = t.closest('[data-rail-prev],[data-rail-next]'))) {
      var rail = visibleRail(sectionOf(el)), track = rail && $('[data-rail-track]', rail);
      if (track) track.scrollBy({ left: (el.hasAttribute('data-rail-next') ? 1 : -1) * Math.max(220, track.clientWidth * 0.8), behavior: REDUCE ? 'auto' : 'smooth' });
      return;
    }
    if ((el = t.closest('[data-lb]'))) { openLb(el); return; }
    if (!t.closest('[data-mega]')) closeMega();
  });
  D.addEventListener('change', function (e) {
    var inp = e.target;
    if (inp && inp.matches && inp.matches('[data-cq-in]')) { var line = inp.closest('.vf-line'); lineChange(line, parseInt(inp.value, 10) || 0); }
  });
  D.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (lb) { closeLb(); return; }
      if (layer) { hideLayer(); return; }
      closeMega();
      return;
    }
    if (lb && (e.key === 'ArrowLeft' || e.key === 'ArrowRight')) { lb.show(lb.i() + (e.key === 'ArrowRight' ? 1 : -1)); return; }
    if (e.key === 'Tab') { if (lb) trap(e, lb.el); else if (layer) trap(e, layer.el); }
  });

  /* ---------- Schubladen aus der (klebenden) Kopfzeile lösen: sonst lägen sie unter dem Abdunkler */
  function portal(root) {
    $$('[data-portal]', root).forEach(function (el) {
      if (el.parentElement === D.body) return;
      var sec = el.closest('.shopify-section');
      el.setAttribute('data-portal-of', sec ? sec.id : '');
      $$('body > [data-portal]').forEach(function (o) { if (o !== el && o.id && o.id === el.id) o.remove(); });
      D.body.appendChild(el);
    });
  }

  /* ---------- Start + Theme-Editor */
  function init(root) {
    root = root || D;
    portal(root);
    hd = $('[data-header]');
    initMega(root); initSearch(root); initProduct(root); initRails(root); initTabs(root);
    initMarquee(root); initAnnFade(root); initUsp(root); initReveal(root); initWords(root); initHero(root); initCollection(root); initCartPage(root); initSpin(root); initEta(root);
    if (root !== D) { initSearch(D); initCollection(D); }   // verschobene Schubladen (Such-Blatt, Filter) liegen jetzt im body
    fitWords(root); litWords();
  }
  measureBars();
  init(D);
  W.VF_OK = true;   // Sicherheitsnetz im Layout: ohne diesen Haken werden nach 3,5 s alle Inhalte ohne Animation gezeigt
  onScroll();
  W.addEventListener('scroll', onScroll, { passive: true });
  var rT = 0, lastW = W.innerWidth;
  W.addEventListener('resize', function () {
    clearTimeout(rT);
    rT = setTimeout(function () {
      measureBars(); updateAllRails(); spinResize();
      if (W.innerWidth !== lastW) { lastW = W.innerWidth; fitWords(D); initMarquee(D); initAnnFade(D); }
    }, 150);
  });
  if (D.fonts && D.fonts.ready) D.fonts.ready.then(function () { fitWords(D); initMarquee(D); initAnnFade(D); updateAllRails(); });
  W.addEventListener('pageshow', function (e) { if (e.persisted && Cart.data) Cart.get().catch(function () {}); });

  if (VF.design || W.Shopify && W.Shopify.designMode) {
    D.addEventListener('shopify:section:load', function (e) { init(e.target); measureBars(); updateAllRails(); spinResize(); });
    D.addEventListener('shopify:section:unload', function (e) {
      $$('body > [data-portal-of="' + e.target.id + '"]').forEach(function (o) { if (layer && layer.el === o) hideLayer(false); o.remove(); });
      $$('[data-spin]', e.target).forEach(function (s) { if (s._spin) spinDestroy(s._spin); });
      $$('[data-usp]', e.target).forEach(function (u) { if (u._t) clearInterval(u._t); });
      if (layer && e.target.contains(layer.el)) hideLayer(false);
    });
    D.addEventListener('shopify:block:select', function (e) {
      var b = e.target;
      var tabs = b.closest && b.closest('[data-tabs]');
      if (tabs && tabs._select && b.matches('[data-tab]')) tabs._select($$('[data-tab]', tabs).indexOf(b));
      var sp = b.closest && b.closest('[data-spin]');
      if (sp && sp._spin && b.matches('[data-spin-tab]')) { var S = sp._spin; S.forced = Number(b.getAttribute('data-spin-tab')); spinActive(S, S.forced); S.lastP = ''; spinKick(); }
      var slide = b.closest && b.closest('[data-rail-track]');
      if (slide) { var li = b.closest('li') || b; slide.scrollTo({ left: li.offsetLeft - slide.offsetLeft, behavior: 'smooth' }); }
    });
    D.addEventListener('shopify:block:deselect', function (e) {
      var sp = e.target.closest && e.target.closest('[data-spin]');
      if (sp && sp._spin) { sp._spin.forced = -1; spinKick(); }
    });
  }
  W.VFTheme = { money: money, cart: Cart, toast: toast };
})();
